"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  EDIT_AT: '__EDIT_AT__',
  CREATE_AT: '__CREATE_AT__',
  TITLE: '__TITLE__',
  SUBTITLE: '__SUBTITLE__'
};